import React from 'react';

import useWidth from '../../../../Hooks/useWidth';
import CommentsCreationForm from '../../../Comments/Creation';

function ReplyButton({ post, ctaVariant }: any) {
  const isMobile = useWidth('down', 'sm');

  return <CommentsCreationForm buttonFullWidth={isMobile} post={post} ctaVariant={ctaVariant} />;
}

export default ReplyButton;
